import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const Check = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'check']}
      {...props}
    />
  );
};
